/**
 * feature-config flag names owned by the content team
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const CONTENT_DYNAMIC_CONFIG_NAMES = {
  CMS_DATABASE_LAST_ACCESSED: 'dc-cont-5952-cms-database-last-accessed',
  // CONT-6173: sampleRate / delaySeconds / toleranceMs for save-durability SLI.
  // sampleRate is a 0-1 fraction; default 0 keeps the check dark until raised.
  CMS_SAVE_DURABILITY_CHECK: 'dc-cont-6173-cms-save-durability',
} as const;

export const CONTENT_FLAG_NAMES = {
  CMS_RTF_RUNTIME_PATCHES: 'ff-cont-2293-apply-cms-rtf-runtime-patches',
  MIGRATE_CMS_RTFS_IN_SITE_MIGRATION_LIFECYCLE:
    'ff-cont-6011-migrate-cms-rtfs-in-site-migration-lifecycle',
  CMS_APOLLO_BATCH_TUNING: 'ff-cont-5981-apollo-batch-tuning',
  // CONT-5981: gates the always-on CMS template-page dynamo RUM metrics
  // (`cmsTemplateDynamoLoad`, `cmsTemplateSaveRefetch`). Rolled out ON — create
  // the Statsig gate at 100% so emission is the steady state; flip to 0% to kill
  // emission without a deploy. Not in `defaultFalseFlags.ts`, so it defaults ON
  // in CI (matching prod steady state).
  CMS_TEMPLATE_DYNAMO_RUM: 'ff-cont-5981-cms-template-dynamo-rum',
  CMS_PUBLICATION_COPY_CAST_DRIFTED_COLUMNS:
    'ff-cont-6617-cms-publication-copy-cast-drifted-columns',
  CMS_ITEM_CREATION_ACROSS_LOCALES:
    'ff-cont-6632-cms-item-creation-across-locales',
  CMS_COBRA_PG_STORAGE_LAYER: 'ff-cont-6545-enable-cms-cobrapg-storage-layer',
};
